export const footer = () => {
    return new Promise((resolve) => {
        const footerEl = document.querySelector('.footer');

        if (footerEl) {
            // Mobile accordion columns (CSS keeps them open on desktop).
            footerEl.querySelectorAll('.footer__col-head').forEach((head) => {
                head.addEventListener('click', () => {
                    head.closest('.footer__col')?.classList.toggle('open');
                });
            });
        }

        resolve();
    })
}
